export default "__VITE_ASSET__324ecbe9__"